module.exports = __webpack_public_path__ + "img/dev04.73482b26.jpg";